import React from 'react';
import {
  Box,
  Grid,
  HStack,
  Skeleton,
  Stat,
  StatLabel,
  StatNumber,
  Text,
  VStack,
} from '@chakra-ui/react';
import { FiTruck, FiPackage, FiActivity, FiClipboard } from 'react-icons/fi';
import { SaktiSpbKpiData } from '../types';
import { SAKTI_UI_SIZE } from '../uiSizes';

interface SaktiSpbKpiCardsProps {
  loading: boolean;
  data: SaktiSpbKpiData;
}

const formatNumber = (value: number) => value.toLocaleString('id-ID');

const SaktiSpbKpiCards: React.FC<SaktiSpbKpiCardsProps> = ({ loading, data }) => {
  const cards = [
    { key: 'total-spb', label: 'TOTAL SPB HARI INI', value: formatNumber(data.total_spb), unit: 'item', icon: FiTruck, color: 'blue' },
    { key: 'total-bunch', label: 'TOTAL JANJANG DIANGKUT', value: formatNumber(data.total_bunch), unit: 'jjg', icon: FiPackage, color: 'green' },
    { key: 'total-loose', label: 'TOTAL BRONDOLAN', value: formatNumber(data.total_loose_fruit), unit: 'kg', icon: FiClipboard, color: 'orange' },
    { key: 'total-weight', label: 'TOTAL TONASE', value: formatNumber(data.total_weight), unit: 'kg', icon: FiActivity, color: 'purple' },
  ];

  return (
    <Grid templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)', xl: 'repeat(4, 1fr)' }} gap={3}>
      {cards.map((card) => (
        <Skeleton key={card.key} isLoaded={!loading} borderRadius={SAKTI_UI_SIZE.cardRadius}>
          <Box bg="white" borderRadius={SAKTI_UI_SIZE.cardRadius} p={SAKTI_UI_SIZE.cardPadding} borderWidth="1px" borderColor="gray.200">
            <VStack align="stretch" spacing={3}>
              <HStack justify="space-between" align="start">
                <Box bg={`${card.color}.50`} color={`${card.color}.600`} borderRadius="md" p={1.5} display="inline-flex" alignItems="center" justifyContent="center" boxSize={SAKTI_UI_SIZE.kpiIconBoxSize}>
                  <card.icon />
                </Box>
              </HStack>
              <Stat>
                <StatLabel fontSize={SAKTI_UI_SIZE.kpiLabel} letterSpacing="wider" color="gray.500">{card.label}</StatLabel>
                <HStack align="end" spacing={1}>
                  <StatNumber fontSize={SAKTI_UI_SIZE.kpiValue}>{card.value}</StatNumber>
                  <Text color="gray.500" pb={1} fontSize="xs">{card.unit}</Text>
                </HStack>
              </Stat>
            </VStack>
          </Box>
        </Skeleton>
      ))}
    </Grid>
  );
};

export default SaktiSpbKpiCards;
